<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">묻고 답하기</p>
          <ul class="depth">
            <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
            <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
            <li><router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">묻고 답하기</h3>
        <article>
          <!--table pc-->
          <div class="table horizontal-table web">
            <table>
              <caption>
                묻고 답하기 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 15%" />
                <col style="width: 35%" />
                <col style="width: 15%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목</th>
                  <td colspan="3">
                    <input type="text" title="제목 입력" v-model="title" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">작성자</th>
                  <td>{{ name }}</td>
                  <th scope="row">작성일자</th>
                  <td>{{ toDay }}</td>
                </tr>
                <tr>
                  <th scope="row">내용</th>
                  <td colspan="3">
                    <textarea v-model="content" style="resize: none"></textarea>
                  </td>
                </tr>
                <tr>
                  <th scope="row">첨부파일</th>
                  <td colspan="3">
                    <div class="fileArea">
                      <p class="upload-name">{{ firstName }}</p>
                      <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile" />
                      <label for="file" class="btn gray">파일첨부</label>
                    </div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">공개설정</th>
                  <td colspan="3">
                    <div class="radioGroup">
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-01"
                          name="public"
                          class="hidden"
                          v-model="isNondisclosure"
                          value="false"
                          @change="hideChange()"
                        />
                        <label for="radio-01">공개</label>
                      </p>
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-02"
                          name="public"
                          class="hidden"
                          v-model="isNondisclosure"
                          value="true"
                          @change="showChange()"
                        />
                        <label for="radio-02">비공개</label>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr v-show="showPassword">
                  <th scope="row">비밀번호</th>
                  <td>
                    <input type="password" title="비밀번호 입력" v-model="password" />
                  </td>
                  <th scope="row">비밀번호 확인</th>
                  <td>
                    <input type="password" title="비밀번호 재입력" v-model="confirmPassword" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table pc-->

          <!--table mobile-->
          <div class="table horizontal-table mobile">
            <table>
              <caption>
                묻고 답하기 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">제목</th>
                  <td colspan="3">
                    <input type="text" title="제목 입력" v-model="title" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">작성자</th>
                  <td>{{ name }}</td>
                </tr>
                <tr>
                  <th scope="row">작성일자</th>
                  <td>{{ toDay }}</td>
                </tr>
                <tr>
                  <th scope="row">내용</th>
                  <td colspan="3">
                    <textarea v-model="content" style="resize: none">내용작성 영역</textarea>
                  </td>
                </tr>
                <tr>
                  <th scope="row">첨부파일</th>
                  <td colspan="3">
                    <div class="fileArea">
                      <p class="upload-name">{{ firstName }}</p>
                      <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile" />
                      <label for="file" class="btn gray">파일첨부</label>
                    </div>
                    <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                  </td>
                </tr>
                <tr>
                  <th scope="row">공개설정</th>
                  <td colspan="3">
                    <div class="radioGroup">
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-01"
                          name="radio"
                          class="hidden"
                          v-model="isNondisclosure"
                          value="false"
                          @change="hideChange()"
                        />
                        <label for="radio-01">공개</label>
                      </p>
                      <p class="radio">
                        <input
                          type="radio"
                          id="radio-02"
                          name="radio"
                          class="hidden"
                          v-model="isNondisclosure"
                          value="true"
                          @change="showChange()"
                        />
                        <label for="radio-02">비공개</label>
                      </p>
                    </div>
                  </td>
                </tr>
                <tr v-show="showPassword">
                  <th scope="row">비밀번호</th>
                  <td>
                    <input type="password" title="비밀번호 입력" v-model="password" />
                  </td>
                </tr>
                <tr v-show="showPassword">
                  <th scope="row">비밀번호 확인</th>
                  <td>
                    <input type="password" title="비밀번호 재입력" v-model="confirmPassword" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--table mobile-->
        </article>
        <article class="btnArea">
          <button class="btn gray" @click="$router.push('qnalist')">취소</button>
          <button class="btn blue" @click="insert">문의하기</button>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg1 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import Alert from '../../../components/Alert01.vue';

export default {
  data() {
    return {
      showModalMsgSuccess: false,
      showPassword: false,

      msg1: '미공개 비밀번호를 분실하실 경우 수정이 불가능합니다.',
      msg2: '관리자에게 문의하시겠습니까?',
      firstName: '파일명',

      applyId: '',
      name: '',
      title: '',
      content: '',
      toDay: '',

      isNondisclosure: 'false',
      password: '',
      confirmPassword: '',
      eFiles: '',
    };
  },

  components: {
    Alert,
  },

  mounted() {
    this.toDay = this.getToday();
    this.applyId = this.$store.state.empNo;
    this.name = this.$store.state.empNm === undefined ? '비회원' : this.$store.state.empNm;
  },

  methods: {
    getToday() {
      const date = new Date();
      const year = date.getFullYear();
      const month = ('0' + (1 + date.getMonth())).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);

      return year + '-' + month + '-' + day;
    },

    CancleBtn() {
      this.showModalMsgFailure = false;
    },

    CloseBtn() {
      this.showModalMsgFailure = false;
    },

    hideChange() {
      this.showPassword = false;
    },

    showChange() {
      this.showPassword = true;
    },

    changeFile(e) {
			const file = e.target.files[0];
			
			if (file.size > 2000000) {
				alert('최대 20mb까지 업로드할 수 있습니다.');
				this.resetFile();
				return;
			}

			if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif' || file['type'] === 'image/jpg' || file['type'] === 'image/pdf' || file['type'] == 'application/pdf') {
				this.firstName = file.name;
				this.eFiles = file;
			}
		},

    resetFile() {
      this.$refs.files.value = '';
      this.eFiles = [];
    },

    async insert() {
      if (this.isNondisclosure == true) {
        if (this.password != this.confirmPassword) {
          alert('비밀번호가 일치하지 않습니다.');
          return;
        } else if ((this.password && this.confirmPassword) == '') {
          alert('비밀번호를 기입 후 등록해주세요.');
          return;
        }
      }
      if ((this.title || this.content) == '') {
        alert('제목과 내용을 모두 작성해주세요');
        return;
      }
      const apiParams = new FormData();
      apiParams.append('writer', this.applyId === undefined ? '비회원' : this.applyId);
      apiParams.append('title', this.title);
      apiParams.append('content', this.content);
      apiParams.append('nondisclosure', this.isNondisclosure === 'true');
      if (this.isNondisclosure === 'true') {
        apiParams.append('password', this.password);
      }
      if (this.eFiles != '') {
        apiParams.append('files', this.eFiles);
      }
      await axios('post', '/api/inquiry/insert', apiParams);
      this.$router.push('/qnalist');
    },
  },
};
</script>
